import { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../context/Provider";
import { login } from "../../../global/context/action/auth/login";
import { useHistory, useLocation } from "react-router";
import { showModal, hideModal } from "../../context/Actions/modal/modal";
import { logoutApp } from "../../../global/context/action/auth/logoutApp";
import { GlobalContext } from "../../../global/context/Provider";
import Layout from "./LoginLayout";
import Loading from "../../components/Genericos/Loading/Loading";
import GetToken from "global/utils/getToken";

const Login = () => {
  const history = useHistory();
  const { modalDispatch, tokenState, laboTurnosState } =
    useContext(PortalContext);

  // Nuevo contexto
  const { authState, authDispatch } = useContext(GlobalContext);
  const [documentoError, setDocumentoError] = useState(false);
  const [centro, setCentro] = useState("");
  const [form, setForm] = useState([
    {
      name: "nro_documento",
      value: "",
      inputType: "number",
      headerStr: "Ingresá tu número de documento",
      placeholderText: "12345678",
      errorStr: "El número de documento no es válido.",
      maxLength: "9",
      className: "inputNonScroll rb16m",
      checkError: documentoError,
      isRequired: true,
      inputMode: "numeric",
      pattern: "[0-9]*",
    },
  ]);
  const loginFormValid = form[0].value.length > 6;
  const search = useLocation().search;

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const irAlPortal = () => {
    window.open("https://portal.dim.com.ar", "_blank");
  };

  //Login y Cambios en el input Form
  const logueando = () => {
    let dto = {
      txtDni: form[0].value,
    };
    // setFlgLogin(true);
    login(dto, ingresoApp)(authDispatch);
  };

  const onInputsChange = (e) => {
    const { name, value } = e.target;

    // Función auxiliar para actualizar un campo en form
    const updateFormField = (fieldName, fieldValue) => {
      setForm((prev) =>
        prev.map((item) =>
          item.name === fieldName ? { ...item, value: fieldValue } : item
        )
      );
    };

    if (name === "nro_documento") {
      // 1) Limpio sólo dígitos
      let cleaned = value.replace(/\D/g, "");

      // 2) Limito a 8 caracteres máximo
      if (cleaned.length > 8) {
        cleaned = cleaned.slice(0, 8);
      }

      // 3) Valido: debe ser 7 u 8 dígitos exactos
      const isValidDni = /^[0-9]{7,8}$/.test(cleaned);

      // 4) Actualizo el error y el formulario
      setDocumentoError(!isValidDni);
      updateFormField(name, cleaned);
    } else {
      // Para otros campos, simplemente guardo el valor crudo
      updateFormField(name, value);
    }
  };

  const ingresoApp = (isCorrect, data) => {
    if (isCorrect) {
      if (centro !== "") {
        history.push("/autocheckin");
      } else {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: "No ingresa por QR",
            // textoNegrita: "Verificá tu clave o usuario e intentá nuevamente",
            texto:
              "Le solicitamos que escanee el QR en el centro más cercano para comenzar su atención. También puede ingresar a portaldim.com.ar para obtener más información.",
            // texto: data.detail,
            danger: true,
            dissmiss: dissmiss,
          },
          [
            {
              text: "Volver",
              clase: "btnAdjust b-latex30 bgc-white rb16m c-latex30",
              accion: dissmiss,
            },
            {
              text: "Ir al Portal",
              clase: "btnAdjust b-latex30 bgc-latex30 rb16m c-white",
              accion: irAlPortal,
            },
          ],
          "centro"
        )(modalDispatch);
        logoutApp(history)(authDispatch);
      }
    } else {
      showModal(
        "Genericos/Mensaje/Mensaje",
        {
          titulo: "Usuario no encontrado",
          // textoNegrita: "Verificá tu clave o usuario e intentá nuevamente",
          texto:
            "Aún no tenés una cuenta creada en el portal de turnos. Ingresá a portaldim.com.ar para registrarte.",
          // texto: data.detail,
          danger: true,
          dissmiss: dissmiss,
        },
        [
          {
            text: "Volver",
            clase: "btnAdjust b-latex30 bgc-white rb16m c-latex30",
            accion: dissmiss,
          },
          {
            text: "Ir al Portal",
            clase: "btnAdjust b-latex30 bgc-latex30 rb16m c-white",
            accion: irAlPortal,
          },
        ],
        "centro"
      )(modalDispatch);
      logoutApp(history)(authDispatch);
    }
  };

  useEffect(() => {
    let token = GetToken(search);
    if (token) {
      const decoded = decodeToken(token);
      setCentro(decoded?.Sede);
      sessionStorage.setItem("centroID", decoded?.Sede);
    }
  }, []);

  const decodeToken = (token) => {
    try {
      const payload = token.split(".")[1];
      const json = atob(payload);
      return JSON.parse(json);
    } catch (e) {
      console.error("Token inválido:", e);
      return null;
    }
  };

  return (
    <>
      <Loading
        dataLoading={
          tokenState.token.loading ||
          laboTurnosState.laboTurnos.data ||
          authState.auth.loading
        }
        descripcion="Cargando..."
        color={"c-white"}
      />
      <Layout
        form={form}
        loading={authState.auth.loading}
        onChange={onInputsChange}
        onSubmit={logueando}
        error={authState.auth.error}
        loginFormValid={loginFormValid}
      />
    </>
  );
};

export default Login;
